@if (edsContent?.edsMyProgress?.edsEvents?.length > 0) {
    <ds-card [elevated]="dsComponents?.dsCardStatic?.elevated" [variant]="dsComponents?.dsCardStatic?.variant">
        <div class="reward-list reward-block">
            <div class="reward-list-title" [ngStyle]="{ 'background-image': 'url(' + edsContent?.titleImage?.image?.src + ')' }">
                {{ edsContent?.titleImage?.title }}
            </div>
            <div class="reward-list-subtitle" [vnDynamicHtml]="edsContent?.titleImage?.parameters?.description"></div>
            <div class="rewards_list">
                @for (event of edsContent?.edsMyProgress?.edsEvents; track event; let rewardIndex = $index) {
                    <div class="eds-accordion mb-2">
                        @if (event?.eventCriteriaInfo && event?.playerRewards?.length > 1) {
                            <div>
                                <div
                                    id="multirewards_{{ rewardIndex }}__header"
                                    class="collapsible__header theme-down"
                                    (click)="eventsToggle('multirewards_' + rewardIndex, event?.eventCriteriaInfo, rewardIndex + 1)">
                                    <div class="collapsible-header-title">
                                        <span class="font-weight-bold" [vnDynamicHtml]="event?.eventCriteriaInfo"></span>
                                        <span class="multi-reward-desc" [vnDynamicHtml]="event?.multiRewardChoiceDesc"></span>
                                    </div>
                                </div>
                                <div id="multirewards_{{ rewardIndex }}__body" class="collapsible__body rewardlist-blocks">
                                    @for (reward of event?.playerRewards; track reward; let rewardNumber = $index) {
                                        <div class="multi-reward-list" results>
                                            @if (event?.totalRewardsClaimed === 0) {
                                                <div class="results row">
                                                    <span class="font-weight-bold col-5" [vnDynamicHtml]="reward?.rewardListDescription"></span>
                                                    <span class="col-7" [vnDynamicHtml]="reward?.rewardDescription"></span>
                                                </div>
                                            }
                                            @if (event?.totalRewardsClaimed > 0 && reward?.rewardStatus === 'Claimed') {
                                                <div>
                                                    <partially-rewarded-result-tile
                                                        class="results-prizes-block cardv2 cardv2-bg text-left"
                                                        [rewardContent]="reward"
                                                        [rewardStatus]="true"
                                                        [title]="reward?.rewardListDescription">
                                                    </partially-rewarded-result-tile>
                                                </div>
                                            }
                                        </div>
                                    }
                                    @if (event?.totalRewardsClaimed > 0 && event?.maxRewardChoice > event?.totalRewardsClaimed) {
                                        <div>
                                            <partially-rewarded-result-tile
                                                class="results-prizes-block cardv2 cardv2-bg text-left"
                                                [rewardContent]="loadPendingPrizeData()"
                                                [rewardStatus]="false">
                                            </partially-rewarded-result-tile>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        @if (event?.eventCriteriaInfo && event?.playerRewards?.length === 1) {
                            <div class="eds-wrapper">
                                <div class="r-row my-cards-top-items">
                                    @if (event?.eventCriteriaInfo) {
                                        <div class="r-col col-6">
                                            <span class="text-truncate reward-row-value" [vnDynamicHtml]="event?.eventCriteriaInfo"></span>
                                        </div>
                                    }
                                    @if (event?.playerRewards[0]?.rewardListDescription) {
                                        <div class="r-col col-6">
                                            <span class="reward-title" [vnDynamicHtml]="event?.playerRewards[0]?.rewardListDescription"></span>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </ds-card>
}
